export enum CivilStatus {
    Single = 0,
    Married = 1,
    Widowed = 2,
    Divorced = 3,
    NewBorn = 4,
    Child = 5,
    Cohabitation = 6,
    Separated = 7,
    Annulled = 8,
    DeFacto = 9,
    Traditional = 10,
}

export const civilStatusOptions = [
    { label: "Single", value: CivilStatus.Single },
    { label: "Married", value: CivilStatus.Married },
    { label: "Widowed", value: CivilStatus.Widowed },
    { label: "Divorced", value: CivilStatus.Divorced },
    { label: "New Born", value: CivilStatus.NewBorn },
    { label: "Child", value: CivilStatus.Child },
    { label: "Cohabitation", value: CivilStatus.Cohabitation },
    { label: "Separated", value: CivilStatus.Separated },
    { label: "Annulled", value: CivilStatus.Annulled },
    { label: "De Facto", value: CivilStatus.DeFacto },
    { label: "Traditional", value: CivilStatus.Traditional },
];

